import {
  CircularProgress,
  CircularProgressProps,
  Theme,
  useTheme,
} from '@mui/material';
import { PropsWithChildren } from 'react';

import { ColorExtractFn } from '@/types/components/common';

import { FullPageBackground, FullPageOverlayBackground } from './Layout.styled';

type FullPageLoaderProps = {
  className?: string;
  color?: CircularProgressProps['color'];
  bgColor?: ColorExtractFn;
} & PropsWithChildren;

export function FullPageLoader({
  className,
  color,
  children,
}: FullPageLoaderProps) {
  return (
    <FullPageBackground className={className}>
      <CircularProgress color={color} />
      {children}
    </FullPageBackground>
  );
}

export function FullPageLoaderOverlay({
  className,
  color,
  bgColor,
}: FullPageLoaderProps) {
  const theme = useTheme();

  return (
    <FullPageOverlayBackground
      className={className}
      bgColor={bgColor?.(theme)}
      data-test-id="full-page-loader-overlay"
    >
      <CircularProgress color={color} />
    </FullPageOverlayBackground>
  );
}

export function FullPageLoaderOverlayWithWhiteBackground() {
  return (
    <FullPageLoaderOverlay
      bgColor={(theme: Theme) => theme.palette.background.paper}
    />
  );
}
